import React, { useState, useEffect, useRef } from "react";
import styles from "./LorriInfo.module.css";

const SECTIONS = {
  intelligence: "Intelligence",
  procurement: "Procurement",
  tms: "TMS",
};

const SECTION_ORDER = [
  SECTIONS.intelligence,
  SECTIONS.procurement,
  SECTIONS.tms,
];

// Update Numbers here
const STATS = {
  [SECTIONS.intelligence]: {
    // districts: 750,
    lanes: 80000,
    transporters: 2500,
  },
  [SECTIONS.procurement]: {
    procured: 500, // in millions
    saved: 21, // in millions
  },
  [SECTIONS.tms]: ["Planning", "Spot", "Indent", "Invoice"],
};

export default function LorriInfo() {
  const [activeSection, setActiveSection] = useState(SECTIONS.intelligence);
  const [isHovered, setIsHovered] = useState(false);
  const intervalRef = useRef(null);
  const [animateKey, setAnimateKey] = useState(0);

  useEffect(() => {
    if (!isHovered) {
      intervalRef.current = setInterval(() => {
        setActiveSection((prev) => {
          const currentIndex = SECTION_ORDER.indexOf(prev);
          const nextIndex = (currentIndex + 1) % SECTION_ORDER.length;
          setAnimateKey(Date.now());
          return SECTION_ORDER[nextIndex];
        });
      }, 3000);
    }

    return () => clearInterval(intervalRef.current);
  }, [isHovered]);

  const handleMouseEnter = (section) => {
    setIsHovered(true);
    setActiveSection(section);
    setAnimateKey(Date.now());
    clearInterval(intervalRef.current);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div className={styles.lorriInfoContainer}>
      <div className={styles.sectionTabs}>
        {Object.values(SECTIONS).map((section, index, array) => (
          <React.Fragment key={section}>
            <div
              onMouseEnter={() => handleMouseEnter(section)}
              onMouseLeave={handleMouseLeave}
              className={`${styles.sectionTab} ${activeSection === section ? styles.activeTab : ""
                }`}
            >
              {section === "TMS" ? (
                <span className={styles.tms}>TMS</span>
              ) : (
                section
              )}
            </div>
            {index < array.length - 1 && (
              <span className={styles.tabSeparator}>•</span>
            )}
          </React.Fragment>
        ))}
      </div>

      <div
        key={animateKey}
        className={`${styles.statsContainer} ${styles.fadeInUp}`}
      >
        {activeSection === SECTIONS.intelligence && (
          <div>
            {/* <span>{STATS[SECTIONS.intelligence].districts}+ Districts</span>
            <span className={styles.stat_marker}>|</span> */}
            <span>
              {STATS[SECTIONS.intelligence].lanes.toLocaleString()}+ Lanes
            </span>
            <span className={styles.stat_marker}>|</span>
            <span>
              {STATS[SECTIONS.intelligence].transporters}+ Transporters
            </span>
          </div>
        )}

        {activeSection === SECTIONS.procurement && (
          <div>
            <span>
              ${STATS[SECTIONS.procurement].procured} million Procured
            </span>
            <span className={styles.stat_marker}>|</span>
            <span>${STATS[SECTIONS.procurement].saved} million Saved</span>
          </div>
        )}

        {activeSection === SECTIONS.tms && (
          <div>
            {STATS[SECTIONS.tms].map((item, index) => (
              <React.Fragment key={item}>
                <span>{item}</span>
                {index < STATS[SECTIONS.tms].length - 1 && (
                  <span className={styles.stat_marker}>|</span>
                )}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
